import { mapState } from "vuex";
import { getUserInfo } from "@/libs/utils";

export default {
  components: {},
  data() {
    return {
      userBaseInfo: getUserInfo(),
    };
  },
  computed: {
    ...mapState(["AllEnums"]),
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
};
